import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHighlights: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHighlights"><Path d="M3.33782 7C2.97522 7.62683 2.6787 8.29667 2.4578 9H12V11H2.04938C2.01672 11.3289 2 11.6625 2 12C2 12.3375 2.01672 12.6711 2.04938 13H12V15H2.4578C2.6787 15.7033 2.97522 16.3732 3.33782 17H12V19H4.85857C6.67349 20.8514 9.20261 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C9.20261 2 6.67349 3.14864 4.85857 5H12V7H3.33782Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHighlights;
